import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";
import FullWithBulletsParagraphConfig from "segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-config";
import FullWithBulletsParagraphAdvancedConfig from "segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-advanced-config";
import TitleAdvancedConfig from "segments/desktop/core-components/title/advanced-field-config";

const { bulletsConfig } = FullWithBulletsParagraphConfig.fields;

const { topTriangle, bottomTriangle, segmentId, segmentMinHeight, ...restOfParagraph } =
  FullWithBulletsParagraphAdvancedConfig.fields;

export default {
  type: FIELD_TYPES.NESTED,
  label: "",
  fields: {
    ...SharedAdvancedFieldsConfig,
    parallaxSpeed: { type: FIELD_TYPES.TEXT, label: "Parallax speed" },
    tagsTitleAdvancedConfig: { type: FIELD_TYPES.NESTED, label: "Tags title", fields: TitleAdvancedConfig },
    tagsVerticalPadding: { type: FIELD_TYPES.TEXT, label: "Tags vertical padding" },
    tagsFontSize: {
      type: FIELD_TYPES.COMBO,
      label: "Tags text size",
      options: [
        { value: "0.8125rem", text: "13px" },
        { value: "0.875rem", text: "14px" }
      ]
    },
    productAdvanceConfig: {
      type: FIELD_TYPES.NESTED,
      label: "Product advanced config",
      fields: {
        productDetailsVerticalPadding: { type: FIELD_TYPES.TEXT, label: "Product details left padding" },
        useCasesAdvancedConfig: {
          type: FIELD_TYPES.NESTED,
          label: "Product use cases",
          fields: {
            horizontalPadding: { type: FIELD_TYPES.TEXT, label: "Horizontal padding" },
            productParagraph: { type: FIELD_TYPES.NESTED, label: "Product paragraph", fields: restOfParagraph },
            bulletTextSize: bulletsConfig.fields.bulletTextSize
          }
        }
      }
    }
  }
};
